import { UseStoreHook, AllFieldsMarker, ALL_FIELDS_MARKER } from "./types";

/**
 * Subscribe to every field of the provided context store, as opposed to just
 * an explicitly listed set of fields. For example:
 * ```
 * const { a, b, c } = useAllFieldsOfContextStore(useMyContextStore);
 * ```
 */
export const useAllFieldsOfContextStore = <S extends object>(
  useContextStore: UseStoreHook<S, AllFieldsMarker>
): ReturnType<UseStoreHook<S, AllFieldsMarker>> =>
  useContextStore(ALL_FIELDS_MARKER);
